import { useRegionsContext } from "../../api/regions";
import Map from "../Map";

export type RegionItem = {
    id: number;
    color: string;
};

export type RegionalMapProps = {
    regionColors: RegionItem[];
    hoveredCountryCodes?: string[];
};

const RegionalMap = ({
    regionColors: regions,
    hoveredCountryCodes = [],
}: RegionalMapProps) => {
    const { regions: regionCountries } = useRegionsContext();

    const countries = regionCountries.flatMap((region) => {
        const regionColor = regions.find((_) => _.id === region.id)?.color;
        if (!regionColor) return [];

        return region.countryCodes.map((countryCode) => ({
            countryCode,
            color: regionColor,
        }));
    });

    return (
        <Map
            className="w-full"
            countries={countries}
            hoveredCountryCodes={hoveredCountryCodes}
        />
    );
};

export default RegionalMap;
